import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"spinner\" data-test-spinner>\n  {{svg-jar \"circle-notch\" class=\"icon-spinner\" aria-label=\"Loading...\"}}\n</div>\n")